import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'pr-references-modal',
    templateUrl: './references-dialog.component.html',
    styleUrls: ['./references-dialog.component.scss']
})
export class ReferencesDialogComponent implements OnInit {

    displayedColumns = ['id', 'name'];

    constructor(
        public dialogRef: MatDialogRef<ReferencesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { id: number, name: string }[],
    ) {
    }

    ngOnInit() {
    }

    onNoClick(): void {
        this.dialogRef.close({deleted: false});
    }

}
